import { Button, Form, Spin } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';
import { GraphQLTaggedNode, useMutation } from 'react-relay';

import useCommitTableRecord from '../hooks/useCommitTableRecord';
import { TableColumnSmxType } from '../types';
import FormFieldByType from './formField/FormFieldByType';
import { getValueByFieldType, getValueForSavingToServer } from './functions';

interface ITableEditForm {
    refButton?: React.MutableRefObject<any>;
    handleForm?: Dispatch<React.SetStateAction<any>>;
    data?: any;
    editableColumns: TableColumnSmxType[];
    connectionId: string;
    mutationCreateOrUpdate: GraphQLTaggedNode;
}

const TableEditForm: React.FC<ITableEditForm> = ({
    refButton,
    handleForm,
    editableColumns,
    data,
    connectionId,
    mutationCreateOrUpdate,
}) => {
    const [commitUpdate] = useMutation(mutationCreateOrUpdate);
    const { getCommitTableRecord } = useCommitTableRecord();

    const [spin] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        data &&
            editableColumns.map((field) => {
                if (field.key in data) {
                    form.setFieldsValue({
                        [field.key]: getValueByFieldType(data[field.key as keyof typeof data], field.typeDecode),
                    });
                }
            });
    }, []);

    const onFinish = (values: any) => {
        if (handleForm) {
            handleForm(true);
        }

        const dataForSaving: { [key: string]: string } = {};

        editableColumns.map((field) => {
            if (field.key in values) {
                dataForSaving[field.key] = getValueForSavingToServer(values[field.key], field.typeDecode);
            }
        });

        const partOfQuery = (mutationCreateOrUpdate as any).params.name
            .replace('Mutation', '')
            .replace(/^\S/, (c: string) => c.toLowerCase());

        commitUpdate(
            getCommitTableRecord(
                dataForSaving,
                connectionId,
                partOfQuery,
                editableColumns,
                data ? data.key : undefined,
            ),
        );
    };

    console.log('==================', data);
    return (
        <Spin spinning={spin} tip={'Please, wait'}>
            <Form
                form={form}
                name={`editForm${data?.key}`}
                style={{ width: '100%' }}
                onFinish={onFinish}
                size={'large'}
                labelCol={{ span: 7 }}
                labelAlign={'left'}
                wrapperCol={{ span: 17 }}
            >
                {editableColumns.map((field) => (
                    <div key={field.key} style={{ marginBottom: 10 }}>
                        <FormFieldByType data={field} />
                    </div>
                ))}
                <Button ref={refButton} htmlType="submit" size={'large'} style={{ display: 'none' }}>
                    Save
                </Button>
            </Form>
        </Spin>
    );
};

export default TableEditForm;
